import React from 'react'
import Button from '#components/a/Button'
import Headline from '#components/a/Headline'
import i18n from 'i18next'
import {useAuth} from 'oidc-react'
import actions from 'redux-auto'

export const PrivacyPolicy = () => {
  const accept = async () => {
    await actions.authentication.acceptPrivacyPolicy()
  }

  const auth = useAuth()
  async function logout(e) {
    e.preventDefault()
    actions.authentication.resetUserData()
    await auth.signOutRedirect({})
  }

  return (
    <div className="privacyPolicy">
      <div className="content-box">
        <Headline modifier="section" importance={2} text={i18n.t('terms_of_use_headline')} />

        <p className="text">
          {i18n.t('terms_of_use_part_one')}
          <a className="linkEdekaYellow" href={i18n.t('terms_of_use_link_url')} target={'terms_of_use'}>
            {i18n.t('terms_of_use_link_text')}
          </a>
          {i18n.t('terms_of_use_part_two')}
          <a className="linkEdekaYellow" href={i18n.t('privacy_policy_link_url')} target={'privacy_policy'}>
            {i18n.t('privacy_policy_link_text')}
          </a>
          {i18n.t('terms_of_use_part_three')}
        </p>

        <div className="privacyPolicyButtons">
          <Button text={i18n.t('terms_of_use_accept')} variant="primary" type="submit" event={accept} />
          <Button text={i18n.t('logout')} variant="secondary" type="reset" event={logout} />
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
